var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 0C19.6544 0 14.9175 1.4369 10.8885 4.12899C6.85953 6.82109 3.71931 10.6475 1.86496 15.1243C0.0106154 19.601 -0.474566 24.5272 0.470772 29.2797C1.41611 34.0322 3.74951 38.3977 7.17589 41.8241C10.6023 45.2505 14.9678 47.5839 19.7203 48.5292C24.4728 49.4746 29.399 48.9894 33.8757 47.135C38.3525 45.2807 42.1789 42.1405 44.871 38.1115C47.5631 34.0825 49 29.3456 49 24.5C49 18.0022 46.4188 11.7705 41.8241 7.17588C37.2295 2.58124 30.9978 0 24.5 0ZM26.2456 35.0044H22.7544V20.9934H26.2609L26.2456 35.0044ZM26.2456 17.5022H22.7544V13.9956H26.2609L26.2456 17.5022Z",
    fill: "#58A9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.097c9977efcab80af510ce33abbfe6b2.svg";
export { ForwardRef as ReactComponent };